module.exports = __webpack_public_path__ + "static/img/shangbiao_02.2259d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_02.png
// module id = 4s7o
// module chunks = 0